module.exports = new __parcel__URL__("fakemon.209011fa.png").toString();